export const all_routes = {
  // dashboard routes
  adminDashboard: "/index",
  parentDashboard: "/parent-dashboard",
  studentDashboard: "/student-dashboard",
  teacherDashboard: "/teacher-dashboard",

  // essential utilities
  calendar: "/calendar",
  dataTables: "/data-tables",
  tablesBasic: "/tables-basic",

  // auth routes
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  success: "/success",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPasswordSuccess: "/reset-password-success",

  // pages routes
  error404: "/error-404",
  error500: "/error-500",
  underMaintenance: "/under-maintenance",

  // settings routes
  customFields: "/app-settings/custom-fields",
  invoiceSettings: "/app-settings/invoice-settings",

  bankAccount: "/financial-settings/bank-account",
  paymentGateways: "/financial-settings/payment-gateways",
  taxRates: "/financial-settings/tax-rates",

  schoolSettings: "/academic-settings/school-settings",
  religion: "/academic-settings/religion",

  connectedApps: "/general-settings/connected-apps",
  notificationssettings: "/general-settings/notifications-settings",
  profilesettings: "/general-settings/profile-settings",
  securitysettings: "/general-settings/security-settings",

  banIpAddress: "/other-settings/ban-ip-address",
  storage: "/other-settings/storage",

  emailSettings: "/system-settings/email-settings",
  emailTemplates: "/system-settings/email-templates",
  gdprCookies: "/system-settings/gdpr-cookies",
  smsSettings: "/system-settings/sms-settings",
  optSettings: "/system-settings/otp-settings",

  socialAuthentication: "/website-settings/social-authentication",
  companySettings: "/website-settings/company-settings",
  language: "/website-settings/language",
  localization: "/website-settings/localization",
  preference: "/website-settings/preference",
  prefixes: "/website-settings/prefixes",

  // content routes (location only)
  cities: "/content/cities",
  states: "/content/states",
  countries: "/content/countries",

  // Peoples Module
  studentGrid: "/student/student-grid",
  studentPromotion: "/student/student-promotion",
  studentDetail: "/student/student-details",
  studentTimeTable: "/student/student-time-table",
  studentLeaves: "/student/student-leaves",
  studentFees: "/student/student-fees",
  studentResult: "/student/student-result",
  studentLibrary: "/student/student-library",
  studentList: "/student/student-list",
  addStudent: "/student/add-student",
  editStudent: "/student/edit-student",
  teacherDetails: "/teacher/teacher-details",
  teacherGrid: "/teacher/teacher-grid",
  teacherList: "/teacher/teacher-list",
  addTeacher: "/teacher/add-teacher",
  editTeacher: "/teacher/edit-teacher",
  teacherLibrary: "/teacher/teacher-library",
  teacherSalary: "/teacher/teacher-salary",
  teacherLeaves: "/teacher/teacher-leaves",
  teachersRoutine: "/teacher/teacher-routine",
  parentGrid: "/parent/parent-grid",
  parentList: "/parent/parent-list",
  guardiansGrid: "/parent/guardians-grid",
  guardiansList: "/parent/guardians-list",

  // Management
  feesGroup: "/management/fees-group",
  feesType: "/management/fees-type",
  feesMaster: "/management/fees-master",
  feesAssign: "/management/fees-assign",
  collectFees: "/management/collect-fees",
  libraryMembers: "/management/library-members",
  libraryIssueBook: "/management/library-issue-book",
  libraryBooks: "/management/library-books",
  libraryReturn: "/management/library-return",
  playerList: "/management/players",
  sportsList: "/management/sports",
  hostelList: "/management/hostel-list",
  hostelType: "/management/hostel-type",
  hostelRoom: "/management/hostel-rooms",
  transportAssignVehicle: "/management/transport-assign-vehicle",
  transportVehicle: "/management/transport-vehicle",
  transportVehicleDrivers: "/management/transport-vehicle-drivers",
  transportPickupPoints: "/management/transport-pickup-points",
  transportRoutes: "/management/transport-routes",

  // Academic module
  AcademicReason: "/academic/academic-reason",
  classSyllabus: "/academic/class-syllabus",
  classSubject: "/academic/class-subject",
  classSection: "/academic/class-section",
  classRoom: "/academic/class-room",
  classRoutine: "/academic/class-routine",
  sheduleClasses: "/academic/schedule-classes",
  classes: "/academic/classes",
  classHomeWork: "/academic/class-home-work",
  exam: "/academic/exam",
  examSchedule: "/academic/exam-schedule",
  grade: "/academic/grade",
  examResult: "/academic/exam-result",
  examAttendance: "/academic/exam-attendance",
  classTimetable: "/academic/class-time-table",

  // HRM module
  staff: "/hrm/staff",
  departments: "/hrm/departments",
  payroll: "/hrm/payroll",
  holidays: "/hrm/holidays",
  designation: "/hrm/designation",
  listLeaves: "/hrm/list-leaves",
  staffDetails: "/hrm/staff-details",
  staffPayroll: "/hrm/staff-payroll",
  staffLeave: "/hrm/staff-leave",
  approveRequest: "/hrm/approve-request",
  studentAttendance: "/hrm/student-attendance",
  teacherAttendance: "/hrm/teacher-attendance",
  staffAttendance: "/hrm/staff-attendance",
  addStaff: "/hrm/add-staff",
  editStaff: "/hrm/edit-staff",
  staffsAttendance: "/hrm/staffs-attendance",

  // finance & accounts routes
  accountsIncome: "/accounts/accounts-income",
  accountsInvoices: "/accounts/accounts-invoices",
  accountsTransactions: "/accounts/accounts-transactions",
  expense: "/accounts/expense",
  expenseCategory: "/accounts/expense-category",
  invoice: "/accounts/invoice",
  addInvoice: "/accounts/add-invoice",
  editInvoice: "/accounts/edit-invoice",

  // announcements routes
  events: "/announcements/events",
  noticeBoard: "/announcements/notice-board",

  // Report
  attendanceReport: "/report/attendance-report",
  classReport: "/report/class-report",
  studentReport: "/report/student-report",
  gradeReport: "/report/grade-report",
  leaveReport: "/report/leave-report",
  feesReport: "/report/fees-report",
  teacherReport: "/report/teacher-report",
  staffReport: "/report/staff-report",
  studentAttendanceType: "/report/student-attendance-type",
  dailyAttendance: "/report/daily-attendance",
  studentDayWise: "/report/student-day-wise",
  teacherDayWise: "/report/teacher-day-wise",
  staffDayWise: "/report/staff-day-wise",

  // page module
  profile: "/pages/profile",
  activity: "/pages/activities",

  // Admin routes - Role-based screens
  userManagement: "/admin/user-management",
  documentRequestsManagement: "/admin/document-requests",
  schoolSchedule: "/admin/school-schedule",
  adminNotifications: "/admin/notifications",
  adminSettings: "/admin/settings",

  // Teacher routes - Role-based screens
  attendanceTracker: "/teacher/attendance-tracker",
  manageHomework: "/teacher/manage-homework",
  alertParents: "/teacher/alert-parents",
  gradeEntry: "/teacher/grade-entry",
  teacherSchedule: "/teacher/schedule",

  // Teacher Module - Complete App Flow
  teacherTasks: "/teacher/tasks",
  teacherMenu: "/teacher/menu",
  teacherClasses: "/teacher/classes",
  teacherStudentsDirectory: "/teacher/students-directory",
  teacherReportStudent: "/teacher/report-student",
  teacherDocumentRequests: "/teacher/document-requests",
  teacherLeaveRequests: "/teacher/leave-requests",
  teacherContactAdmin: "/teacher/contact-admin",
  teacherReportIssues: "/teacher/report-issues",

  // Teacher Module - Additional Components
  teacherProfile: "/teacher/profile",
  teacherSettings: "/teacher/settings",
  teacherHelp: "/teacher/help",
  teacherMessages: "/teacher/messages",
  teacherNotifications: "/teacher/notifications",
  teacherAttendanceHistory: "/teacher/attendance-history",
  teacherHomeworkHistory: "/teacher/homework-history",
  teacherAnnouncementsSent: "/teacher/announcements-sent",
  teacherAnalytics: "/teacher/analytics",
  teacherGradesOverview: "/teacher/grades-overview",

  // Student routes - Role-based screens
  gradeList: "/student/grade-list",
  attendanceView: "/student/attendance-view",
  homeworkList: "/student/homework-list",
  documentRequestForm: "/student/document-requests",
  todoList: "/student/todo-list",
  studentNoticeBoard: "/shared/notice-board",
  studentClasses: "/student/classes",
  studentTasks: "/student/tasks",
  studentMenu: "/student/menu",
  studentEvents: "/student/events",
  studentMessages: "/student/messages",
  studentNotifications: "/student/notifications",
  studentHelp: "/student/help",
  studentSettings: "/student/settings",

  // Parent routes - Role-based screens
  viewStudentProfile: "/parent/student-profile",
  studentGrades: "/parent/student-grades",
  studentAttendanceView: "/parent/student-attendance",
  paymentHistory: "/parent/payment-history",
  parentDocumentRequests: "/parent/document-requests",

  // Parent Module - New Routes
  parentHomework: "/parent/homework",
  parentTasks: "/parent/tasks",
  parentMenu: "/parent/menu",
  parentAttendanceHistory: "/parent/attendance-history",
  parentSchedule: "/parent/schedule",
  parentHomeworkHistory: "/parent/homework-history",
  parentGradesOverview: "/parent/grades-overview",
  parentPaymentsHistory: "/parent/payments-history",
  parentDocuments: "/parent/documents",
  parentEventsCalendar: "/parent/events-calendar",
  parentMessages: "/parent/messages",
  parentNotifications: "/parent/notifications",
  parentSettings: "/parent/settings",
  parentHelp: "/parent/help",

  // Support routes - Role-based screens
  supportDashboard: "/support/dashboard",
  supportUserAccess: "/support/user-access",
  allDocumentRequests: "/support/document-requests",
  reportedIssues: "/support/reported-issues",
};
